import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0081',
    ecrans: ['00-2'],
    params: ['?eplcleint','?unpcleint','?datede','?datea', '?creation']
});
